import { TrendingUp } from "lucide-react";
import { C } from "../../theme/tokens";

export function AuthLoadingScreen({ t }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: `radial-gradient(circle at 50% 35%, ${C.green}22 0%, transparent 38%), ${C.canvas}`,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "relative",
          width: 84,
          height: 84,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 22,
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 26,
            border: `1px solid ${C.greenBright}55`,
            background: `linear-gradient(135deg, ${C.deep} 0%, ${C.green} 100%)`,
            boxShadow: `0 0 34px ${C.greenBright}25`,
            transform: "rotate(45deg)",
            animation: "authLogoPulse 2.2s ease-in-out infinite",
          }}
        />
        <TrendingUp size={34} color={C.primary} strokeWidth={2.5} style={{ position: "relative" }} />
      </div>
      <div
        style={{
          color: C.primary,
          fontSize: 21,
          fontWeight: 700,
          letterSpacing: "0.02em",
          fontFamily: "'Space Grotesk', sans-serif",
        }}
      >
        EXP TRADE PRO
      </div>
      <div
        style={{
          marginTop: 8,
          color: C.violetBright,
          fontSize: 10.5,
          fontWeight: 600,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        Market intelligence
      </div>
      <div style={{ color: C.secondary, fontSize: 13.5, fontFamily: "'Space Grotesk', sans-serif", marginTop: 28 }}>
        {t.auth_loading}
      </div>
      <div
        aria-hidden="true"
        style={{
          width: 116,
          height: 3,
          marginTop: 14,
          overflow: "hidden",
          borderRadius: 99,
          background: C.hairline,
        }}
      >
        <div
          style={{
            width: "42%",
            height: "100%",
            borderRadius: "inherit",
            background: `linear-gradient(90deg, ${C.greenBright}, ${C.violetBright})`,
            animation: "authProgress 1.5s ease-in-out infinite",
          }}
        />
      </div>
      <style>{`
        @keyframes authLogoPulse {
          0%, 100% { transform: rotate(45deg) scale(1); opacity: .86; }
          50% { transform: rotate(45deg) scale(1.07); opacity: 1; }
        }
        @keyframes authProgress {
          0% { transform: translateX(-145%); }
          100% { transform: translateX(290%); }
        }
      `}</style>
    </div>
  );
}
